module.exports = __webpack_public_path__ + "img/product_05.97b7b4f3.png";